<template>
    <x-page :title="pageTitle">
        <template #header-actions>
            <x-back-button :disabled="isLoading" :display-warning="false" />
        </template>
        <sms-form
            id="sms-form"
            v-if="resource"
            :disabled="true"
            :initialFields="resource"
        />
    </x-page>
</template>

<script>
import XBackButton from "../../components/XBackButton.vue";
import XPage from "../../components/XPage.vue";
import { handleGeneralXhrError } from "../../helpers";
import PermissionMixin from "../../mixins/PermissionMixin";
import SmsForm from "./SmsForm.vue";

export default {
    components: {
        XPage,
        XBackButton,
        SmsForm,
    },
    computed: {
        pageTitle() {
            let title = ["Histori SMS"];

            if (this.resource) {
                title.push(this.resource.title);
            }

            return title.join(" | ");
        },
    },
    created() {
        this.fetchResource();
    },
    data() {
        return {
            errors: null,
            isLoading: false,
            resource: null,
        };
    },
    methods: {
        fetchResource() {
            this.isLoading = true;
            const request = axios
                .get(`/api/sms/${this.$route.params.id}`)
                .then((response) => {
                    this.resource = response.data.data;
                });
            return handleGeneralXhrError(request).finally(() => {
                this.isLoading = false;
            });
        },
    },
    mixins: [PermissionMixin],
};
</script>
